var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isAvailable
    ? _c(
        "div",
        [
          _c(
            "b-btn",
            {
              staticClass: "btn-card-action my-1",
              on: { click: _vm.preProlong },
            },
            [
              _vm._v(
                "Продлить закупочную сессию до " +
                  _vm._s(
                    _vm.getDateTimeFormat(
                      _vm.purchase.flags.max_prolong_datetime
                    )
                  )
              ),
            ]
          ),
          _c(
            "b-modal",
            {
              ref: "delete-modal",
              attrs: {
                centered: "",
                "hide-header-close": "",
                "no-close-on-backdrop": "",
                "no-close-on-esc": "",
                title: "Продлить закупочную сессию",
              },
              model: {
                value: _vm.isModalVisible,
                callback: function ($$v) {
                  _vm.isModalVisible = $$v
                },
                expression: "isModalVisible",
              },
            },
            [
              _c("div", { staticClass: "d-block text-left" }, [
                _vm._v(
                  "Вы действительно хотите продлить закупочную сессию " +
                    _vm._s(_vm.purchase.purchase_info.reg_number) +
                    " до " +
                    _vm._s(
                      _vm.getDateTimeFormat(
                        _vm.purchase.flags.max_prolong_datetime
                      )
                    ) +
                    "?"
                ),
              ]),
              _c(
                "div",
                {
                  staticClass: "w-100 text-right",
                  attrs: { slot: "modal-footer" },
                  slot: "modal-footer",
                },
                [
                  _c(
                    "b-overlay",
                    {
                      staticClass: "d-inline-block",
                      attrs: {
                        show: _vm.isDataSending,
                        opacity: "0.6",
                        rounded: "",
                        "spinner-small": "",
                        "spinner-variant": "primary",
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "text-uppercase mr-2",
                          attrs: { variant: "custom-outline-secondary" },
                          on: { click: _vm.cancelModal },
                        },
                        [_vm._v("Отмена")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-overlay",
                    {
                      staticClass: "d-inline-block",
                      attrs: {
                        show: _vm.isDataSending,
                        opacity: "0.6",
                        rounded: "",
                        "spinner-small": "",
                        "spinner-variant": "primary",
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "text-uppercase",
                          attrs: { variant: "custom-green" },
                          on: { click: _vm.prolongPurchase },
                        },
                        [_vm._v("Продлить")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }